import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoints } from '@naf/theme';

export const MapContainer = styled.div<{ inArticle: boolean }>`
  height: 440px;

  ${({ inArticle }) =>
    inArticle
      ? css``
      : css`
          width: 100%;
        `}

  grid-column: 3 / -3;

  @media (max-width: ${breakpoints.m}) {
    grid-column: 1 / -1;
  }
`;
